const origin = {
  leadOriginAll: 'lead-list.lead-origin.all',
  leadOriginConversion: 'lead-list.lead-origin.conversion',
  leadOriginImport: 'lead-list.lead-origin.import',
}

export const originForSelect = Object.entries(origin).map(([value, text]) => ({ value, text }))

export default origin
